unit uFrmMain;

interface

uses
  System.SysUtils, Vcl.Forms, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls, WEBLib.Controls, WEBLib.ExtCtrls,
  uSubForm1, uSubForm2, Unit1, Unit2, Unit3, Unit4, WEBLib.Buttons,
  Vcl.Imaging.jpeg, WEBLib.DBCtrls, Data.DB, WEBLib.DB, WEBLib.CDS, Vcl.Grids,
  VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCCustomControl, VCL.TMSFNCTrackBar, VCL.TMSFNCRangeSlider,
  WEBLib.JQCtrls, Vcl.Graphics, Vcl.Imaging.pngimage;

type
  TFrmMain = class(TForm)
    txtSampleText: TEdit;
    HostPanel: TPanel;
    WebGroupBox1: TGroupBox;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebEdit1: TEdit;
    Logo: TImageControl;
    WebPanel1: TPanel;
    WebSplitter1: TSplitter;
    WebBitBtn3: TBitBtn;
    WebBitBtn4: TBitBtn;
    WebBitBtn5: TBitBtn;
    WebBitBtn6: TBitBtn;
    WebBitBtn7: TBitBtn;
    WebBitBtn8: TBitBtn;
    WebLabel1: TLabel;
    WebEdit2: TEdit;
    WebLabel4: TLabel;
    WebEdit3: TEdit;
    WebLabel5: TLabel;
    WebEdit4: TEdit;
    WebLabel6: TLabel;
    WebEdit5: TEdit;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    WebEdit8: TEdit;
    WebEdit9: TEdit;
    WebEdit10: TEdit;
    WebEdit11: TEdit;
    WebLabel17: TLabel;
    WebLabel18: TLabel;
    WebLabel19: TLabel;
    WebLabel20: TLabel;
    WebEdit16: TEdit;
    WebEdit17: TEdit;
    WebLabel27: TLabel;
    WebLabel12: TLabel;
    WebLabel15: TLabel;
    WebLabel13: TLabel;
    Przycisk: TImageControl;
    WebEdit6: TEdit;
    WebEdit7: TEdit;
    WebEdit12: TEdit;
    WebEdit13: TEdit;
    WebEdit14: TEdit;
    Motyl: TImageControl;
    WebLabel14: TLabel;
    Opis: TImageControl;
    WebLabel16: TLabel;
    procedure btCreateSubF1Click(Sender: TObject);
    procedure btRemoveSubFormClick(Sender: TObject);
    procedure btTransferSetClick(Sender: TObject);
    procedure btCreateSubF2Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure btTransferGetClick(Sender: TObject);
    procedure WebButton3Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure comboStateChange(Sender: TObject);
    procedure comboCountryChange(Sender: TObject);
    procedure WebBitBtn1Click(Sender: TObject);
    procedure LogoClick(Sender: TObject);
    procedure WebBitBtn2Click(Sender: TObject);
    procedure WebBitBtn3Click(Sender: TObject);
    procedure WebBitBtn4Click(Sender: TObject);
    procedure WebBitBtn5Click(Sender: TObject);
    procedure WebBitBtn6Click(Sender: TObject);
    procedure WebBitBtn7Click(Sender: TObject);
    procedure WebBitBtn8Click(Sender: TObject);
    procedure WebBitBtn9Click(Sender: TObject);
    procedure WebBitBtn10Click(Sender: TObject);
  public
    frm: TForm;
    procedure ValidateForm; overload;
  protected procedure LoadDFMValues; override; end;

    TCountry = class(TPersistent)
  private
    FName: string;
    FCode: string;
    FContinent: string;
  public
    property Name: string read FName write FName;
    property Code: string read FCode write FCode;
    property Continent: string read FContinent write FContinent;
  end;

var
  FrmMain: TFrmMain;
  MIE, JED, TRA, URO, ZAK, RAZ : Real;


implementation

{$R *.dfm}


procedure TFrmMain.ValidateForm;
var
  edvalid, edinvalid: string;
begin
  edvalid := 'form-control';
  edinvalid := 'form-control is-invalid';

end;


procedure TFrmMain.btCreateSubF1Click(Sender: TObject);

  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TSubForm1) then
  end;

begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TSubForm1.CreateNew(HostPanel.ElementID, @AfterCreate);
end;

procedure TFrmMain.btRemoveSubFormClick(Sender: TObject);

  procedure AfterCreate(AForm: TObject);
  begin
//    if Assigned(frm) and (frm is Unit1) then
  end;
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

//  frm :=  TUnit1.CreateNew(HostPanel.ElementID, @AfterCreate);
end;

procedure TFrmMain.btTransferSetClick(Sender: TObject);
begin
  if Assigned(frm) and (frm is TSubForm1) then
end;

procedure TFrmMain.comboCountryChange(Sender: TObject);
var
  cc: string;
begin

end;

procedure TFrmMain.comboStateChange(Sender: TObject);
begin
ValidateForm;
end;

procedure TFrmMain.btCreateSubF2Click(Sender: TObject);
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TSubForm1) then
  end;

begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TSubForm2.CreateNew(HostPanel.ElementID, nil);
end;

procedure TFrmMain.btTransferGetClick(Sender: TObject);
begin
  if Assigned(frm) and (frm is TSubForm1) then
end;

procedure TFrmMain.WebBitBtn10Click(Sender: TObject);
var   AF : String;
begin

end;

procedure TFrmMain.WebBitBtn1Click(Sender: TObject);
var    edvalid, edinvalid: string;

begin

end;

procedure TFrmMain.WebBitBtn2Click(Sender: TObject);
var  im   : Integer;
     L    : String;
begin

end;

procedure TFrmMain.WebBitBtn3Click(Sender: TObject);

  procedure AfterCreate(AForm: TObject);
  begin
   //    if Assigned(frm) and (frm is TSubForm1) then
  end;

begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TSubForm1.CreateNew(HostPanel.ElementID, @AfterCreate);
  WebBitBtn4.Enabled:=True;
  WebBitBtn4.Visible:=True;
  end;

procedure TFrmMain.WebBitBtn4Click(Sender: TObject);
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TSubForm1) then
  end;

begin
  if WebEdit6.Text='1' then begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TSubForm2.CreateNew(HostPanel.ElementID, nil);
  WebBitBtn5.Enabled:=True;
  WebBitBtn5.Visible:=True;
  WebBitBtn3.Enabled:=False;
  end
  else begin
  MessageDlg('Proszę udzielić wszyskich odpowiedzi !!!', mtInformation, []);
  End;
end;

procedure TFrmMain.WebBitBtn5Click(Sender: TObject);
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TForm1) then
  end;
begin
  if WebEdit7.Text='1' then begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TForm1.CreateNew(HostPanel.ElementID, @AfterCreate);
  WebBitBtn6.Enabled:=True;
  WebBitBtn6.Visible:=True;
  WebBitBtn4.Enabled:=False;
  end
  else begin
  MessageDlg('Proszę udzielić wszyskich odpowiedzi !!!', mtInformation, []);
  End;
end;

procedure TFrmMain.WebBitBtn6Click(Sender: TObject);
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TForm2) then
  end;
begin
  if WebEdit12.Text='1' then begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TForm2.CreateNew(HostPanel.ElementID, @AfterCreate);
  WebBitBtn7.Enabled:=True;
  WebBitBtn7.Visible:=True;
  WebBitBtn5.Enabled:=False;
  end
  else begin
  MessageDlg('Proszę udzielić wszyskich odpowiedzi !!!', mtInformation, []);
  End;
end;

procedure TFrmMain.WebBitBtn7Click(Sender: TObject);
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TForm3) then
  end;
begin
  if WebEdit13.Text='1' then begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TForm3.CreateNew(HostPanel.ElementID, @AfterCreate);
  WebBitBtn8.Enabled:=True;
  WebBitBtn8.Visible:=True;
  WebBitBtn6.Enabled:=False;
  WebBitBtn7.Enabled:=False;
  end
  else begin
  MessageDlg('Proszę udzielić wszyskich odpowiedzi !!!', mtInformation, []);
  End;
end;

procedure TFrmMain.WebBitBtn8Click(Sender: TObject);
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TForm4) then
  end;
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

 frm :=  TForm4.CreateNew(HostPanel.ElementID, @AfterCreate);
end;

procedure TFrmMain.WebBitBtn9Click(Sender: TObject);
var   IL     : Integer;
begin
end;

procedure TFrmMain.WebButton2Click(Sender: TObject);
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TForm4) then
  end;
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TForm4.CreateNew(HostPanel.ElementID, @AfterCreate);
end;

procedure TFrmMain.WebButton3Click(Sender: TObject);

  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TForm3) then
  end;
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TForm3.CreateNew(HostPanel.ElementID, @AfterCreate);
end;

procedure TFrmMain.WebFormCreate(Sender: TObject);
var
        bt, ed, lb, co  : string;
   edvalid, edinvalid   : string;

begin
end;

procedure TFrmMain.LogoClick(Sender: TObject);
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TFrmMain.CreateNew();
end;

procedure TFrmMain.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel15 := TLabel.Create(Self);
  HostPanel := TPanel.Create(Self);
  WebLabel27 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  Przycisk := TImageControl.Create(Self);
  Motyl := TImageControl.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  Opis := TImageControl.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  Logo := TImageControl.Create(Self);
  WebGroupBox1 := TGroupBox.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel17 := TLabel.Create(Self);
  WebLabel18 := TLabel.Create(Self);
  WebLabel19 := TLabel.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  txtSampleText := TEdit.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebEdit4 := TEdit.Create(Self);
  WebEdit5 := TEdit.Create(Self);
  WebEdit8 := TEdit.Create(Self);
  WebEdit9 := TEdit.Create(Self);
  WebEdit10 := TEdit.Create(Self);
  WebEdit11 := TEdit.Create(Self);
  WebEdit16 := TEdit.Create(Self);
  WebEdit17 := TEdit.Create(Self);
  WebBitBtn3 := TBitBtn.Create(Self);
  WebBitBtn4 := TBitBtn.Create(Self);
  WebBitBtn5 := TBitBtn.Create(Self);
  WebBitBtn6 := TBitBtn.Create(Self);
  WebBitBtn7 := TBitBtn.Create(Self);
  WebBitBtn8 := TBitBtn.Create(Self);
  WebSplitter1 := TSplitter.Create(Self);
  WebEdit6 := TEdit.Create(Self);
  WebEdit7 := TEdit.Create(Self);
  WebEdit12 := TEdit.Create(Self);
  WebEdit13 := TEdit.Create(Self);
  WebEdit14 := TEdit.Create(Self);

  WebLabel15.BeforeLoadDFMValues;
  HostPanel.BeforeLoadDFMValues;
  WebLabel27.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  Przycisk.BeforeLoadDFMValues;
  Motyl.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  Opis.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  Logo.BeforeLoadDFMValues;
  WebGroupBox1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  txtSampleText.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebEdit4.BeforeLoadDFMValues;
  WebEdit5.BeforeLoadDFMValues;
  WebEdit8.BeforeLoadDFMValues;
  WebEdit9.BeforeLoadDFMValues;
  WebEdit10.BeforeLoadDFMValues;
  WebEdit11.BeforeLoadDFMValues;
  WebEdit16.BeforeLoadDFMValues;
  WebEdit17.BeforeLoadDFMValues;
  WebBitBtn3.BeforeLoadDFMValues;
  WebBitBtn4.BeforeLoadDFMValues;
  WebBitBtn5.BeforeLoadDFMValues;
  WebBitBtn6.BeforeLoadDFMValues;
  WebBitBtn7.BeforeLoadDFMValues;
  WebBitBtn8.BeforeLoadDFMValues;
  WebSplitter1.BeforeLoadDFMValues;
  WebEdit6.BeforeLoadDFMValues;
  WebEdit7.BeforeLoadDFMValues;
  WebEdit12.BeforeLoadDFMValues;
  WebEdit13.BeforeLoadDFMValues;
  WebEdit14.BeforeLoadDFMValues;
  try
    Name := 'FrmMain';
    Width := 828;
    Height := 749;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -13;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebLabel15.SetParentComponent(Self);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 33;
    WebLabel15.Top := 127;
    WebLabel15.Width := 296;
    WebLabel15.Height := 16;
    WebLabel15.Caption := 'Jakie jest g'#322#243'wne ogrzewanie Twojego domu zim'#261'?';
    WebLabel15.HeightPercent := 100.000000000000000000;
    WebLabel15.WidthPercent := 100.000000000000000000;
    HostPanel.SetParentComponent(Self);
    HostPanel.Name := 'HostPanel';
    HostPanel.Left := 0;
    HostPanel.Top := 256;
    HostPanel.Width := 828;
    HostPanel.Height := 493;
    HostPanel.HeightPercent := 100.000000000000000000;
    HostPanel.WidthPercent := 100.000000000000000000;
    HostPanel.Align := alBottom;
    HostPanel.BorderColor := clSilver;
    HostPanel.BorderStyle := bsSingle;
    HostPanel.Color := clWhite;
    WebLabel27.SetParentComponent(HostPanel);
    WebLabel27.Name := 'WebLabel27';
    WebLabel27.Left := 8;
    WebLabel27.Top := 471;
    WebLabel27.Width := 252;
    WebLabel27.Height := 16;
    WebLabel27.Caption := 'Kalkulator fotowoltaiczny - Pro-Sun (c) 2022';
    WebLabel27.Color := clYellow;
    WebLabel27.HeightPercent := 100.000000000000000000;
    WebLabel27.Transparent := False;
    WebLabel27.WidthPercent := 100.000000000000000000;
    WebLabel13.SetParentComponent(HostPanel);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 8;
    WebLabel13.Top := 65;
    WebLabel13.Width := 337;
    WebLabel13.Height := 29;
    WebLabel13.Caption := 'Kalkulator '#347'ladu w'#281'glowego';
    WebLabel13.Font.Charset := DEFAULT_CHARSET;
    WebLabel13.Font.Color := clBlue;
    WebLabel13.Font.Height := -24;
    WebLabel13.Font.Name := 'Tahoma';
    WebLabel13.Font.Style := [fsBold];
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.ParentFont := False;
    WebLabel13.Transparent := False;
    WebLabel13.WidthPercent := 100.000000000000000000;
    Przycisk.SetParentComponent(HostPanel);
    Przycisk.Name := 'Przycisk';
    Przycisk.Left := 523;
    Przycisk.Top := 334;
    Przycisk.Width := 126;
    Przycisk.Height := 50;
    Przycisk.HeightPercent := 100.000000000000000000;
    Przycisk.WidthPercent := 100.000000000000000000;
    Przycisk.ChildOrder := 3;
    Przycisk.Picture.LoadFromFile('uFrmMain.HostPanel.Przycisk.Picture.png');
    Motyl.SetParentComponent(HostPanel);
    Motyl.Name := 'Motyl';
    Motyl.Left := 8;
    Motyl.Top := 199;
    Motyl.Width := 431;
    Motyl.Height := 266;
    Motyl.HeightPercent := 100.000000000000000000;
    Motyl.WidthPercent := 100.000000000000000000;
    Motyl.ChildOrder := 5;
    Motyl.Picture.LoadFromFile('uFrmMain.HostPanel.Motyl.Picture.jpg');
    WebLabel14.SetParentComponent(HostPanel);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 445;
    WebLabel14.Top := 296;
    WebLabel14.Width := 258;
    WebLabel14.Height := 16;
    WebLabel14.Caption := 'Aby rozpocz'#261'c test prosz'#281' klikn'#261#263' na przycisk';
    WebLabel14.Font.Charset := DEFAULT_CHARSET;
    WebLabel14.Font.Color := clRed;
    WebLabel14.Font.Height := -13;
    WebLabel14.Font.Name := 'Tahoma';
    WebLabel14.Font.Style := [];
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.ParentFont := False;
    WebLabel14.WidthPercent := 100.000000000000000000;
    Opis.SetParentComponent(HostPanel);
    Opis.Name := 'Opis';
    Opis.Left := 8;
    Opis.Top := 104;
    Opis.Width := 705;
    Opis.Height := 89;
    Opis.HeightPercent := 100.000000000000000000;
    Opis.WidthPercent := 100.000000000000000000;
    Opis.ChildOrder := 5;
    Opis.Picture.LoadFromFile('uFrmMain.HostPanel.Opis.Picture.png');
    WebLabel16.SetParentComponent(HostPanel);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 564;
    WebLabel16.Top := 471;
    WebLabel16.Width := 150;
    WebLabel16.Height := 16;
    WebLabel16.Caption := 'Kontakt: biuro@pro-sun.pl';
    WebLabel16.Font.Charset := DEFAULT_CHARSET;
    WebLabel16.Font.Color := clBlue;
    WebLabel16.Font.Height := -13;
    WebLabel16.Font.Name := 'Tahoma';
    WebLabel16.Font.Style := [];
    WebLabel16.HeightPercent := 100.000000000000000000;
    WebLabel16.ParentFont := False;
    WebLabel16.WidthPercent := 100.000000000000000000;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 828;
    WebPanel1.Height := 218;
    WebPanel1.HeightPercent := 100.000000000000000000;
    WebPanel1.WidthPercent := 100.000000000000000000;
    WebPanel1.Align := alTop;
    WebPanel1.BorderColor := clSilver;
    WebPanel1.BorderStyle := bsSingle;
    WebPanel1.ChildOrder := 9;
    Logo.SetParentComponent(WebPanel1);
    Logo.Name := 'Logo';
    Logo.Left := 0;
    Logo.Top := 0;
    Logo.Width := 828;
    Logo.Height := 113;
    Logo.HeightPercent := 100.000000000000000000;
    Logo.WidthPercent := 100.000000000000000000;
    Logo.Align := alTop;
    Logo.ChildOrder := 8;
    SetEvent(Logo, Self, 'OnClick', 'LogoClick');
    Logo.Picture.LoadFromFile('uFrmMain.WebPanel1.Logo.Picture.png');
    WebGroupBox1.SetParentComponent(WebPanel1);
    WebGroupBox1.Name := 'WebGroupBox1';
    WebGroupBox1.Left := 0;
    WebGroupBox1.Top := 113;
    WebGroupBox1.Width := 828;
    WebGroupBox1.Height := 52;
    WebGroupBox1.HeightPercent := 100.000000000000000000;
    WebGroupBox1.WidthPercent := 100.000000000000000000;
    WebGroupBox1.Align := alTop;
    WebGroupBox1.BorderColor := clSilver;
    WebGroupBox1.Caption := ' '#346'lad CO2 ';
    WebGroupBox1.ChildOrder := 12;
    WebGroupBox1.Color := clMoneyGreen;
    WebLabel2.SetParentComponent(WebGroupBox1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 83;
    WebLabel2.Top := 12;
    WebLabel2.Width := 56;
    WebLabel2.Height := 14;
    WebLabel2.Caption := 'Mieszkanie';
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -12;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [];
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebGroupBox1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 159;
    WebLabel3.Top := 12;
    WebLabel3.Width := 47;
    WebLabel3.Height := 14;
    WebLabel3.Caption := 'Jedzenie';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -12;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [];
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(WebGroupBox1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 234;
    WebLabel1.Top := 12;
    WebLabel1.Width := 53;
    WebLabel1.Height := 14;
    WebLabel1.Caption := 'Transport';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -12;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebGroupBox1);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 304;
    WebLabel4.Top := 12;
    WebLabel4.Width := 46;
    WebLabel4.Height := 14;
    WebLabel4.Caption := 'Wakacje';
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -12;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [];
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebGroupBox1);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 383;
    WebLabel5.Top := 12;
    WebLabel5.Width := 39;
    WebLabel5.Height := 14;
    WebLabel5.Caption := 'Zakupy';
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := -12;
    WebLabel5.Font.Name := 'Tahoma';
    WebLabel5.Font.Style := [];
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(WebGroupBox1);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 594;
    WebLabel6.Top := 12;
    WebLabel6.Width := 40;
    WebLabel6.Height := 14;
    WebLabel6.Caption := 'Razem';
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clBlue;
    WebLabel6.Font.Height := -12;
    WebLabel6.Font.Name := 'Tahoma';
    WebLabel6.Font.Style := [fsBold];
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(WebGroupBox1);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 361;
    WebLabel7.Top := 31;
    WebLabel7.Width := 16;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'ton';
    WebLabel7.Font.Charset := DEFAULT_CHARSET;
    WebLabel7.Font.Color := clWindowText;
    WebLabel7.Font.Height := -11;
    WebLabel7.Font.Name := 'Tahoma';
    WebLabel7.Font.Style := [];
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.ParentFont := False;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(WebGroupBox1);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 440;
    WebLabel8.Top := 31;
    WebLabel8.Width := 16;
    WebLabel8.Height := 13;
    WebLabel8.Caption := 'ton';
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clWindowText;
    WebLabel8.Font.Height := -11;
    WebLabel8.Font.Name := 'Tahoma';
    WebLabel8.Font.Style := [];
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.ParentFont := False;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(WebGroupBox1);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 649;
    WebLabel9.Top := 30;
    WebLabel9.Width := 16;
    WebLabel9.Height := 13;
    WebLabel9.Caption := 'ton';
    WebLabel9.Font.Charset := DEFAULT_CHARSET;
    WebLabel9.Font.Color := clWindowText;
    WebLabel9.Font.Height := -11;
    WebLabel9.Font.Name := 'Tahoma';
    WebLabel9.Font.Style := [];
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.ParentFont := False;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebLabel10.SetParentComponent(WebGroupBox1);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 211;
    WebLabel10.Top := 31;
    WebLabel10.Width := 16;
    WebLabel10.Height := 13;
    WebLabel10.Caption := 'ton';
    WebLabel10.Font.Charset := DEFAULT_CHARSET;
    WebLabel10.Font.Color := clWindowText;
    WebLabel10.Font.Height := -11;
    WebLabel10.Font.Name := 'Tahoma';
    WebLabel10.Font.Style := [];
    WebLabel10.HeightPercent := 100.000000000000000000;
    WebLabel10.ParentFont := False;
    WebLabel10.WidthPercent := 100.000000000000000000;
    WebLabel11.SetParentComponent(WebGroupBox1);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 282;
    WebLabel11.Top := 31;
    WebLabel11.Width := 16;
    WebLabel11.Height := 13;
    WebLabel11.Caption := 'ton';
    WebLabel11.Font.Charset := DEFAULT_CHARSET;
    WebLabel11.Font.Color := clWindowText;
    WebLabel11.Font.Height := -11;
    WebLabel11.Font.Name := 'Tahoma';
    WebLabel11.Font.Style := [];
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.ParentFont := False;
    WebLabel11.WidthPercent := 100.000000000000000000;
    WebLabel17.SetParentComponent(WebGroupBox1);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 846;
    WebLabel17.Top := 52;
    WebLabel17.Width := 59;
    WebLabel17.Height := 16;
    WebLabel17.Caption := 'Orientacja';
    WebLabel17.HeightPercent := 100.000000000000000000;
    WebLabel17.Visible := False;
    WebLabel17.WidthPercent := 100.000000000000000000;
    WebLabel18.SetParentComponent(WebGroupBox1);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 845;
    WebLabel18.Top := -2;
    WebLabel18.Width := 55;
    WebLabel18.Height := 16;
    WebLabel18.Caption := 'Po'#322'o'#380'enie';
    WebLabel18.HeightPercent := 100.000000000000000000;
    WebLabel18.Visible := False;
    WebLabel18.WidthPercent := 100.000000000000000000;
    WebLabel19.SetParentComponent(WebGroupBox1);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 851;
    WebLabel19.Top := 14;
    WebLabel19.Width := 34;
    WebLabel19.Height := 16;
    WebLabel19.Caption := 'Modul';
    WebLabel19.HeightPercent := 100.000000000000000000;
    WebLabel19.Visible := False;
    WebLabel19.WidthPercent := 100.000000000000000000;
    WebLabel20.SetParentComponent(WebGroupBox1);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 846;
    WebLabel20.Top := 36;
    WebLabel20.Width := 45;
    WebLabel20.Height := 16;
    WebLabel20.Caption := 'Inverter';
    WebLabel20.HeightPercent := 100.000000000000000000;
    WebLabel20.Visible := False;
    WebLabel20.WidthPercent := 100.000000000000000000;
    WebLabel12.SetParentComponent(WebGroupBox1);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 135;
    WebLabel12.Top := 30;
    WebLabel12.Width := 16;
    WebLabel12.Height := 13;
    WebLabel12.Caption := 'ton';
    WebLabel12.Font.Charset := DEFAULT_CHARSET;
    WebLabel12.Font.Color := clWindowText;
    WebLabel12.Font.Height := -11;
    WebLabel12.Font.Name := 'Tahoma';
    WebLabel12.Font.Style := [];
    WebLabel12.HeightPercent := 100.000000000000000000;
    WebLabel12.ParentFont := False;
    WebLabel12.WidthPercent := 100.000000000000000000;
    txtSampleText.SetParentComponent(WebGroupBox1);
    txtSampleText.Name := 'txtSampleText';
    txtSampleText.Left := 82;
    txtSampleText.Top := 27;
    txtSampleText.Width := 47;
    txtSampleText.Height := 20;
    txtSampleText.Color := 16777200;
    txtSampleText.Enabled := False;
    txtSampleText.HeightPercent := 100.000000000000000000;
    txtSampleText.Text := '0';
    txtSampleText.WidthPercent := 100.000000000000000000;
    WebEdit1.SetParentComponent(WebGroupBox1);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 159;
    WebEdit1.Top := 27;
    WebEdit1.Width := 47;
    WebEdit1.Height := 20;
    WebEdit1.ChildOrder := 7;
    WebEdit1.Color := 16777200;
    WebEdit1.Enabled := False;
    WebEdit1.HeightPercent := 100.000000000000000000;
    WebEdit1.Text := '0';
    WebEdit1.WidthPercent := 100.000000000000000000;
    WebEdit2.SetParentComponent(WebGroupBox1);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 234;
    WebEdit2.Top := 27;
    WebEdit2.Width := 42;
    WebEdit2.Height := 20;
    WebEdit2.ChildOrder := 7;
    WebEdit2.Color := 16777200;
    WebEdit2.Enabled := False;
    WebEdit2.HeightPercent := 100.000000000000000000;
    WebEdit2.Text := '0';
    WebEdit2.WidthPercent := 100.000000000000000000;
    WebEdit3.SetParentComponent(WebGroupBox1);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 306;
    WebEdit3.Top := 27;
    WebEdit3.Width := 49;
    WebEdit3.Height := 20;
    WebEdit3.ChildOrder := 7;
    WebEdit3.Color := 16777200;
    WebEdit3.Enabled := False;
    WebEdit3.HeightPercent := 100.000000000000000000;
    WebEdit3.Text := '0';
    WebEdit3.WidthPercent := 100.000000000000000000;
    WebEdit4.SetParentComponent(WebGroupBox1);
    WebEdit4.Name := 'WebEdit4';
    WebEdit4.Left := 383;
    WebEdit4.Top := 27;
    WebEdit4.Width := 51;
    WebEdit4.Height := 20;
    WebEdit4.ChildOrder := 7;
    WebEdit4.Color := 16777200;
    WebEdit4.Enabled := False;
    WebEdit4.HeightPercent := 100.000000000000000000;
    WebEdit4.Text := '0';
    WebEdit4.WidthPercent := 100.000000000000000000;
    WebEdit5.SetParentComponent(WebGroupBox1);
    WebEdit5.Name := 'WebEdit5';
    WebEdit5.Left := 594;
    WebEdit5.Top := 27;
    WebEdit5.Width := 47;
    WebEdit5.Height := 20;
    WebEdit5.ChildOrder := 7;
    WebEdit5.Color := clYellow;
    WebEdit5.Enabled := False;
    WebEdit5.HeightPercent := 100.000000000000000000;
    WebEdit5.Text := '0';
    WebEdit5.WidthPercent := 100.000000000000000000;
    WebEdit8.SetParentComponent(WebGroupBox1);
    WebEdit8.Name := 'WebEdit8';
    WebEdit8.Left := 903;
    WebEdit8.Top := 46;
    WebEdit8.Width := 69;
    WebEdit8.Height := 19;
    WebEdit8.ChildOrder := 20;
    WebEdit8.HeightPercent := 100.000000000000000000;
    WebEdit8.Text := '-';
    WebEdit8.Visible := False;
    WebEdit8.WidthPercent := 100.000000000000000000;
    WebEdit9.SetParentComponent(WebGroupBox1);
    WebEdit9.Name := 'WebEdit9';
    WebEdit9.Left := 903;
    WebEdit9.Top := -2;
    WebEdit9.Width := 69;
    WebEdit9.Height := 19;
    WebEdit9.ChildOrder := 21;
    WebEdit9.HeightPercent := 100.000000000000000000;
    WebEdit9.Text := '-';
    WebEdit9.Visible := False;
    WebEdit9.WidthPercent := 100.000000000000000000;
    WebEdit10.SetParentComponent(WebGroupBox1);
    WebEdit10.Name := 'WebEdit10';
    WebEdit10.Left := 903;
    WebEdit10.Top := 16;
    WebEdit10.Width := 28;
    WebEdit10.Height := 19;
    WebEdit10.ChildOrder := 22;
    WebEdit10.HeightPercent := 100.000000000000000000;
    WebEdit10.Text := '0';
    WebEdit10.Visible := False;
    WebEdit10.WidthPercent := 100.000000000000000000;
    WebEdit11.SetParentComponent(WebGroupBox1);
    WebEdit11.Name := 'WebEdit11';
    WebEdit11.Left := 903;
    WebEdit11.Top := 35;
    WebEdit11.Width := 28;
    WebEdit11.Height := 19;
    WebEdit11.ChildOrder := 23;
    WebEdit11.HeightPercent := 100.000000000000000000;
    WebEdit11.Text := '0';
    WebEdit11.Visible := False;
    WebEdit11.WidthPercent := 100.000000000000000000;
    WebEdit16.SetParentComponent(WebGroupBox1);
    WebEdit16.Name := 'WebEdit16';
    WebEdit16.Left := 932;
    WebEdit16.Top := 16;
    WebEdit16.Width := 41;
    WebEdit16.Height := 19;
    WebEdit16.ChildOrder := 36;
    WebEdit16.HeightPercent := 100.000000000000000000;
    WebEdit16.Text := '0';
    WebEdit16.Visible := False;
    WebEdit16.WidthPercent := 100.000000000000000000;
    WebEdit17.SetParentComponent(WebGroupBox1);
    WebEdit17.Name := 'WebEdit17';
    WebEdit17.Left := 932;
    WebEdit17.Top := 35;
    WebEdit17.Width := 42;
    WebEdit17.Height := 19;
    WebEdit17.ChildOrder := 37;
    WebEdit17.HeightPercent := 100.000000000000000000;
    WebEdit17.Text := '0';
    WebEdit17.Visible := False;
    WebEdit17.WidthPercent := 100.000000000000000000;
    WebBitBtn3.SetParentComponent(WebPanel1);
    WebBitBtn3.Name := 'WebBitBtn3';
    WebBitBtn3.Left := 3;
    WebBitBtn3.Top := 168;
    WebBitBtn3.Width := 114;
    WebBitBtn3.Height := 47;
    WebBitBtn3.Align := alCustom;
    WebBitBtn3.Caption := 'Dom';
    WebBitBtn3.Color := clBtnFace;
    WebBitBtn3.Glyph.LoadFromFile('uFrmMain.WebPanel1.WebBitBtn3.Glyph.png');
    WebBitBtn3.HeightPercent := 100.000000000000000000;
    WebBitBtn3.TabOrder := 1;
    WebBitBtn3.WidthPercent := 100.000000000000000000;
    SetEvent(WebBitBtn3, Self, 'OnClick', 'WebBitBtn3Click');
    WebBitBtn4.SetParentComponent(WebPanel1);
    WebBitBtn4.Name := 'WebBitBtn4';
    WebBitBtn4.Left := 119;
    WebBitBtn4.Top := 168;
    WebBitBtn4.Width := 117;
    WebBitBtn4.Height := 47;
    WebBitBtn4.Align := alCustom;
    WebBitBtn4.Caption := 'Jedzenie';
    WebBitBtn4.Color := clBtnFace;
    WebBitBtn4.Glyph.LoadFromFile('uFrmMain.WebPanel1.WebBitBtn4.Glyph.png');
    WebBitBtn4.HeightPercent := 100.000000000000000000;
    WebBitBtn4.TabOrder := 2;
    WebBitBtn4.Visible := False;
    WebBitBtn4.WidthPercent := 100.000000000000000000;
    SetEvent(WebBitBtn4, Self, 'OnClick', 'WebBitBtn4Click');
    WebBitBtn5.SetParentComponent(WebPanel1);
    WebBitBtn5.Name := 'WebBitBtn5';
    WebBitBtn5.Left := 238;
    WebBitBtn5.Top := 168;
    WebBitBtn5.Width := 117;
    WebBitBtn5.Height := 47;
    WebBitBtn5.Align := alCustom;
    WebBitBtn5.Caption := 'Transport';
    WebBitBtn5.Color := clBtnFace;
    WebBitBtn5.Enabled := False;
    WebBitBtn5.Glyph.LoadFromFile('uFrmMain.WebPanel1.WebBitBtn5.Glyph.png');
    WebBitBtn5.HeightPercent := 100.000000000000000000;
    WebBitBtn5.TabOrder := 3;
    WebBitBtn5.Visible := False;
    WebBitBtn5.WidthPercent := 100.000000000000000000;
    SetEvent(WebBitBtn5, Self, 'OnClick', 'WebBitBtn5Click');
    WebBitBtn6.SetParentComponent(WebPanel1);
    WebBitBtn6.Name := 'WebBitBtn6';
    WebBitBtn6.Left := 357;
    WebBitBtn6.Top := 168;
    WebBitBtn6.Width := 117;
    WebBitBtn6.Height := 47;
    WebBitBtn6.Align := alCustom;
    WebBitBtn6.Caption := 'Wakacje';
    WebBitBtn6.Color := clBtnFace;
    WebBitBtn6.Enabled := False;
    WebBitBtn6.Glyph.LoadFromFile('uFrmMain.WebPanel1.WebBitBtn6.Glyph.png');
    WebBitBtn6.HeightPercent := 100.000000000000000000;
    WebBitBtn6.TabOrder := 4;
    WebBitBtn6.Visible := False;
    WebBitBtn6.WidthPercent := 100.000000000000000000;
    SetEvent(WebBitBtn6, Self, 'OnClick', 'WebBitBtn6Click');
    WebBitBtn7.SetParentComponent(WebPanel1);
    WebBitBtn7.Name := 'WebBitBtn7';
    WebBitBtn7.Left := 476;
    WebBitBtn7.Top := 168;
    WebBitBtn7.Width := 116;
    WebBitBtn7.Height := 47;
    WebBitBtn7.Align := alCustom;
    WebBitBtn7.Caption := 'Zakupy';
    WebBitBtn7.Color := clBtnFace;
    WebBitBtn7.Enabled := False;
    WebBitBtn7.Glyph.LoadFromFile('uFrmMain.WebPanel1.WebBitBtn7.Glyph.png');
    WebBitBtn7.HeightPercent := 100.000000000000000000;
    WebBitBtn7.TabOrder := 5;
    WebBitBtn7.Visible := False;
    WebBitBtn7.WidthPercent := 100.000000000000000000;
    SetEvent(WebBitBtn7, Self, 'OnClick', 'WebBitBtn7Click');
    WebBitBtn8.SetParentComponent(WebPanel1);
    WebBitBtn8.Name := 'WebBitBtn8';
    WebBitBtn8.Left := 594;
    WebBitBtn8.Top := 168;
    WebBitBtn8.Width := 119;
    WebBitBtn8.Height := 47;
    WebBitBtn8.Align := alCustom;
    WebBitBtn8.Caption := 'Wynik';
    WebBitBtn8.Color := clBtnFace;
    WebBitBtn8.Enabled := False;
    WebBitBtn8.Glyph.LoadFromFile('uFrmMain.WebPanel1.WebBitBtn8.Glyph.png');
    WebBitBtn8.HeightPercent := 100.000000000000000000;
    WebBitBtn8.TabOrder := 6;
    WebBitBtn8.Visible := False;
    WebBitBtn8.WidthPercent := 100.000000000000000000;
    SetEvent(WebBitBtn8, Self, 'OnClick', 'WebBitBtn8Click');
    WebSplitter1.SetParentComponent(Self);
    WebSplitter1.Name := 'WebSplitter1';
    WebSplitter1.Left := 976;
    WebSplitter1.Top := 0;
    WebSplitter1.Width := 1;
    WebSplitter1.Height := 289;
    WebSplitter1.HeightPercent := 100.000000000000000000;
    WebSplitter1.WidthPercent := 100.000000000000000000;
    WebSplitter1.Align := alNone;
    WebSplitter1.ChildOrder := 3;
    WebSplitter1.Color := clBtnFace;
    WebEdit6.SetParentComponent(Self);
    WebEdit6.Name := 'WebEdit6';
    WebEdit6.Left := 4;
    WebEdit6.Top := 221;
    WebEdit6.Width := 113;
    WebEdit6.Height := 22;
    WebEdit6.ChildOrder := 4;
    WebEdit6.HeightPercent := 100.000000000000000000;
    WebEdit6.Text := '0';
    WebEdit6.Visible := False;
    WebEdit6.WidthPercent := 100.000000000000000000;
    WebEdit7.SetParentComponent(Self);
    WebEdit7.Name := 'WebEdit7';
    WebEdit7.Left := 122;
    WebEdit7.Top := 221;
    WebEdit7.Width := 116;
    WebEdit7.Height := 22;
    WebEdit7.ChildOrder := 5;
    WebEdit7.HeightPercent := 100.000000000000000000;
    WebEdit7.Text := '0';
    WebEdit7.Visible := False;
    WebEdit7.WidthPercent := 100.000000000000000000;
    WebEdit12.SetParentComponent(Self);
    WebEdit12.Name := 'WebEdit12';
    WebEdit12.Left := 242;
    WebEdit12.Top := 221;
    WebEdit12.Width := 113;
    WebEdit12.Height := 22;
    WebEdit12.ChildOrder := 6;
    WebEdit12.HeightPercent := 100.000000000000000000;
    WebEdit12.Text := '0';
    WebEdit12.Visible := False;
    WebEdit12.WidthPercent := 100.000000000000000000;
    WebEdit13.SetParentComponent(Self);
    WebEdit13.Name := 'WebEdit13';
    WebEdit13.Left := 361;
    WebEdit13.Top := 221;
    WebEdit13.Width := 113;
    WebEdit13.Height := 22;
    WebEdit13.ChildOrder := 7;
    WebEdit13.HeightPercent := 100.000000000000000000;
    WebEdit13.Text := '0';
    WebEdit13.Visible := False;
    WebEdit13.WidthPercent := 100.000000000000000000;
    WebEdit14.SetParentComponent(Self);
    WebEdit14.Name := 'WebEdit14';
    WebEdit14.Left := 476;
    WebEdit14.Top := 221;
    WebEdit14.Width := 119;
    WebEdit14.Height := 22;
    WebEdit14.ChildOrder := 8;
    WebEdit14.HeightPercent := 100.000000000000000000;
    WebEdit14.Text := '0';
    WebEdit14.Visible := False;
    WebEdit14.WidthPercent := 100.000000000000000000;
  finally
    WebLabel15.AfterLoadDFMValues;
    HostPanel.AfterLoadDFMValues;
    WebLabel27.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    Przycisk.AfterLoadDFMValues;
    Motyl.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    Opis.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    Logo.AfterLoadDFMValues;
    WebGroupBox1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    txtSampleText.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebEdit4.AfterLoadDFMValues;
    WebEdit5.AfterLoadDFMValues;
    WebEdit8.AfterLoadDFMValues;
    WebEdit9.AfterLoadDFMValues;
    WebEdit10.AfterLoadDFMValues;
    WebEdit11.AfterLoadDFMValues;
    WebEdit16.AfterLoadDFMValues;
    WebEdit17.AfterLoadDFMValues;
    WebBitBtn3.AfterLoadDFMValues;
    WebBitBtn4.AfterLoadDFMValues;
    WebBitBtn5.AfterLoadDFMValues;
    WebBitBtn6.AfterLoadDFMValues;
    WebBitBtn7.AfterLoadDFMValues;
    WebBitBtn8.AfterLoadDFMValues;
    WebSplitter1.AfterLoadDFMValues;
    WebEdit6.AfterLoadDFMValues;
    WebEdit7.AfterLoadDFMValues;
    WebEdit12.AfterLoadDFMValues;
    WebEdit13.AfterLoadDFMValues;
    WebEdit14.AfterLoadDFMValues;
  end;
end;

end.


